module.exports = __webpack_public_path__ + "static/media/fleetdriverIcon.d71edf38.svg";